import { getVariable } from '@/common/env'

export const MINIMAL_BET = getVariable('ThirdGameMinimalBet') ?? 0
